import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=f3900202&scoped=true"
import script from "./OrderDialog.vue?vue&type=script&lang=js"
export * from "./OrderDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=f3900202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9b90bd239842d9ab132761d251f24808/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3900202",
  null
  
)

export default component.exports